<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconBackgroundBlurLight_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <g clip-path="url(#IconBackgroundBlurLight_16__a)">
        <g clip-path="url(#IconBackgroundBlurLight_16__b)">
            <circle cx="2.333" cy="2.5" r=".333" fill="currentColor" />
            <circle cx="5.083" cy="2.5" r=".5" fill="currentColor" />
            <circle cx="8" cy="2.5" r=".5" fill="currentColor" />
            <circle cx="10.917" cy="2.5" r=".5" fill="currentColor" />
            <g filter="url(#IconBackgroundBlurLight_16__c)">
                <circle cx="13.667" cy="2.5" r=".333" fill="currentColor" />
            </g>
            <circle cx="5.333" cy="10.667" r=".667" fill="currentColor" />
            <path
                fill="currentColor"
                d="M8 8q-.687 0-1.177-.49a1.6 1.6 0 0 1-.49-1.177q0-.687.49-1.177T8 4.666t1.177.49.49 1.177-.49 1.177T8 8m-2.5 3.333a.8.8 0 0 1-.588-.244.8.8 0 0 1-.245-.589v-.333q0-.355.182-.652.183-.296.484-.453.646-.322 1.313-.484a5.74 5.74 0 0 1 2.708 0q.667.163 1.313.484.302.158.484.453.182.298.182.652v.333q0 .344-.244.589a.8.8 0 0 1-.589.244z"
            />
            <circle cx="2.333" cy="13.5" r=".333" fill="currentColor" />
            <circle cx="5.083" cy="13.5" r=".5" fill="currentColor" />
            <circle cx="8" cy="13.5" r=".5" fill="currentColor" />
            <circle cx="10.917" cy="13.5" r=".5" fill="currentColor" />
            <circle cx="13.667" cy="13.5" r=".333" fill="currentColor" />
            <circle
                cx="13.5"
                cy="5.167"
                r=".5"
                fill="currentColor"
                transform="rotate(90 13.5 5.167)"
            />
            <circle
                cx="13.5"
                cy="7.833"
                r=".5"
                fill="currentColor"
                transform="rotate(90 13.5 7.833)"
            />
            <circle
                cx="2.5"
                cy="5.167"
                r=".5"
                fill="currentColor"
                transform="rotate(90 2.5 5.167)"
            />
            <circle
                cx="2.5"
                cy="7.833"
                r=".5"
                fill="currentColor"
                transform="rotate(90 2.5 7.833)"
            />
            <circle
                cx="13.5"
                cy="10.5"
                r=".5"
                fill="currentColor"
                transform="rotate(90 13.5 10.5)"
            />
            <circle
                cx="2.5"
                cy="10.5"
                r=".5"
                fill="currentColor"
                transform="rotate(90 2.5 10.5)"
            />
        </g>
        <circle cx=".333" cy="8" r=".333" fill="currentColor" />
        <circle cx="8" cy=".333" r=".333" fill="currentColor" />
        <circle cx="8" cy="15.667" r=".333" fill="currentColor" />
        <circle cx="15.667" cy="8" r=".333" fill="currentColor" />
    </g>
    <defs>
        <clipPath id="IconBackgroundBlurLight_16__a">
            <path fill="currentColor" d="M0 0h16v16H0z" />
        </clipPath>
        <clipPath id="IconBackgroundBlurLight_16__b">
            <path fill="currentColor" d="M2 2h12v12H2z" />
        </clipPath>
        <filter
            id="IconBackgroundBlurLight_16__c"
            width="6"
            height="6"
            x="10.667"
            y="2.167"
            color-interpolation-filters="sRGB"
            filterUnits="userSpaceOnUse"
        >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dy="2.667" />
            <feGaussianBlur stdDeviation="1.333" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
                in2="BackgroundImageFix"
                result="effect1_dropShadow_6106_393"
            />
            <feBlend
                in="SourceGraphic"
                in2="effect1_dropShadow_6106_393"
                result="shape"
            />
        </filter>
    </defs>
</svg>
